import { FieldTypes } from '../../constants/FieldTypes'
import { BooleanField, DropdownField, Field, TextAreaField } from '../../types/forms/fields'

import { DropdownOptionItem } from '../../types/forms/fields'
import { getBooleanHistoryField } from '../shared'

export const getConditionOrDiseaseFields = (
  id: string,
  placeholder: string,
  specifyOptions?: Array<DropdownOptionItem>,
  detailsPlaceholder?: string,
  otherFields?: Record<string, Field>,
): Record<string, Field> => {
  let fields: Record<string, Field> = {
    [id]: getBooleanHistoryField(placeholder),
  }
  if (specifyOptions?.length) {
    fields[`${id}Specify`] = {
      type: FieldTypes.MULTIPLE_SELECT,
      placeholder: 'Please specify',
      options: specifyOptions,
      condition: v => !!v?.[id],
    }
    if (specifyOptions.some(option => option.id === 'other')) {
      fields[`${id}SpecifyOther`] = {
        type: FieldTypes.TEXT,
        placeholder: 'Other condition or disease',
        condition: v => v?.[`${id}Specify`]?.includes('other'),
      }
    }
  }
  if (otherFields) {
    fields = {
      ...fields,
      ...otherFields,
    }
  }
  fields[`${id}Details`] = {
    type: FieldTypes.TEXTAREA,
    placeholder: detailsPlaceholder ?? 'Please provide any details about your experience',
    condition: v => !!v?.[id],
    optional: true,
  }
  return fields
}

export const getDetailsField = (
  conditionalOn: string,
  placeholder?: string,
  optional?: boolean,
  withDotPhrases?: boolean,
): TextAreaField => ({
  placeholder: placeholder ?? 'Details...',
  type: FieldTypes.TEXTAREA,
  condition: v => v?.[conditionalOn],
  withDotPhrases,
  optional,
})

export const getYesNoRadioField = (placeholder: string): BooleanField => ({
  type: FieldTypes.BOOLEAN,
  placeholder,
  inputType: 'radio',
  yesText: 'Yes',
  noText: 'No',
})

export const getYesNoUnknownField = (placeholder: string): DropdownField => ({
  type: FieldTypes.DROPDOWN,
  placeholder,
  inputType: 'radio',
  options: [
    {
      text: 'No',
      id: 'no',
    },
    {
      text: 'Unknown',
      id: 'unknown',
    },
    {
      text: 'Yes',
      id: 'yes',
    },
  ],
})
